import { LoadingOutlined } from '@ant-design/icons'
import { Flex, Typography } from 'antd'
import React, { ReactNode } from 'react'

type Props = {
  title?: ReactNode
}

export const LoaderOverlay: React.FC<Props> = ({ title }) => {
  return (
    <Flex className="w-full h-full" align="center" justify="center" vertical>
      {title && <Typography.Text type="secondary">{title}</Typography.Text>}
      <Typography.Title>
        <LoadingOutlined />
      </Typography.Title>
    </Flex>
  )
}
